import { QueryClientProvider } from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';

import { AppRoutes } from '@/app-routes';
import favicon from '@/assets/img/favicon.png';
import { ColorSchemeScript, DirectionProvider, MantineProvider } from '@mantine/core';
import { theme } from '@/shared/theme';

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-datatable/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/code-highlight/styles.css';
import '@mantine/spotlight/styles.css';
import '@mantine/dropzone/styles.css';
import '@gfazioli/mantine-led/styles.css';
import '@mantine-bites/lightbox/styles.css';

import { queryClient } from '@/api-client/query-client';
import { ModalsProvider } from '@mantine/modals';
import './index.css'
import { SocketsProvider } from '@/shared/libs/sockets/sockets.context';


function App() {
    return (
        <QueryClientProvider client={ queryClient }>
            <DirectionProvider>
                <ColorSchemeScript defaultColorScheme='dark'/>
                <MantineProvider
                    theme={ theme }
                    forceColorScheme='dark'
                >
                    <ModalsProvider>
                        <link rel='icon' type='image/png' href={ favicon }/>
                        <SocketsProvider>
                            <AppRoutes/>
                        </SocketsProvider>
                        
                        <ToastContainer
                            style={ { top: 59, zIndex: 999999, filter: 'none !important' } }
                            autoClose={ 4000 }
                            theme={ 'dark' }
                            draggable={ false }
                            closeOnClick
                        />
                    </ModalsProvider>
                </MantineProvider>
            </DirectionProvider>
        </QueryClientProvider>
    );
}

export default App;
